import { change } from 'redux-form';
import { Identifiable } from '@mews/std';
import { SearchResult, CommanderThunkAction } from '@mews-commander/types';
import { createUrlFromPath, getPathFromUrl } from '@mews-commander/utils';
import { openNewEntityBackendDialog } from '../../app/components/SearchNewEntityDialogBackendPage';
import { preselectSearchResult } from './index';

interface CreateNewEntityArgs {
    scope: string;
    form: string;
    field: string;
}

export const createNewSearchFormEntity =
    ({
        url,
        searchType,
        scope,
        form,
        field,
    }: Pick<SearchResult, 'url' | 'searchType'> & CreateNewEntityArgs): CommanderThunkAction =>
    (dispatch, _) => {
        if (url == null) return;

        const onSuccess = async ({ id }: Identifiable) => {
            dispatch(change(form, field, id));
            return dispatch(preselectSearchResult({ searchTypes: [searchType], id }, scope));
        };

        openNewEntityBackendDialog({ onSuccess, searchType, url });
    };
export const createNewSearchHookFormEntity =
    (
        { searchType, url }: Pick<SearchResult, 'searchType' | 'url'>,
        onDataReceived: (identifiable: Identifiable) => void
    ): CommanderThunkAction =>
    () => {
        if (!url) return;

        openNewEntityBackendDialog({ onSuccess: onDataReceived, searchType, url });
    };
export const enhanceCustomerCreateUrl = (path?: string, enterpriseId?: string) => {
    const url = createUrlFromPath(path || global.location.href);
    url.searchParams.set('RedirectToProfile', 'false');
    if (enterpriseId) {
        url.searchParams.set('EnterpriseId', enterpriseId);
    }
    return getPathFromUrl(url);
};
